import GoogleReviews from'./GoogleReviews';export default GoogleReviews;